import React, { useEffect, useRef, useState } from 'react';
import {
    getFunScoreMoment,
    SCORE_ANIMATION_DURATION_MS
} from '../scoreAnimations';
import { subscribeToScoreChanges } from '../scoreEvents';

export default function ScoreAnimationToast({ enabled }) {
    const [moment, setMoment] = useState(null);
    const [imageFailed, setImageFailed] = useState(false);
    const timeoutRef = useRef(null);

    useEffect(() => {
        return subscribeToScoreChanges(({ redScore, blueScore }) => {
            if (!enabled) return;

            const nextMoment = getFunScoreMoment(redScore, blueScore);
            if (!nextMoment) return;

            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }

            setMoment({
                ...nextMoment,
                key: `${redScore}-${blueScore}-${Date.now()}`
            });
            setImageFailed(false);
            timeoutRef.current = setTimeout(() => {
                setMoment(null);
                timeoutRef.current = null;
            }, SCORE_ANIMATION_DURATION_MS);
        });
    }, [enabled]);

    useEffect(() => {
        if (enabled) return undefined;

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setMoment(null);

        return undefined;
    }, [enabled]);

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    if (!moment) {
        return null;
    }

    return (
        <div
            key={moment.key}
            className="score-animation-toast"
            role="status"
            aria-live="polite"
            style={{ '--score-animation-duration': `${SCORE_ANIMATION_DURATION_MS}ms` }}
        >
            <div className="score-animation-card">
                {imageFailed ? (
                    <div className="score-animation-image-fallback" aria-label={moment.image.alt}>
                        {moment.title}
                    </div>
                ) : (
                    <img
                        src={moment.image.url}
                        alt={moment.image.alt}
                        className="score-animation-image"
                        onError={() => setImageFailed(true)}
                    />
                )}
                <div className="score-animation-copy">
                    <strong>{moment.title}</strong>
                    <span>{moment.message}</span>
                </div>
            </div>
        </div>
    );
}
